export function selectImage(imageIndex) {
	return {
		type: 'IMAGE_SELECTED',
		payload: imageIndex
	};
}



// WEBPACK FOOTER //
// ./src/actions/index.js